import React from 'react';
import type { HTMLAttributes } from 'react';
import type { TabsProps } from './types';

type Ref = HTMLDivElement;
type HTMLProps = Omit<HTMLAttributes<Ref>, 'id'>;
interface Props extends Pick<TabsProps, 'id' | 'active'>, HTMLProps {
  /**
   * Tab control identification.
   */
  control: string;
  /**
   * Tab panel content.
   */
  children: React.ReactNode;
}

const TabPanel = React.forwardRef<Ref, Props>(({
  id,
  active,
  control,
  children,
  ...other
}: Props, ref): JSX.Element => (
  <div
    ref={ref}
    role={'tabpanel'}
    id={`tabpanel--${control}_${id}`}
    aria-labelledby={`tab--${control}_${id}`}
    tabIndex={0}
    hidden={id !== active}
    {...other as HTMLProps}
  >
    {children}
  </div>
));

TabPanel.displayName = 'TabPanel';

export default TabPanel;
